// extracted by mini-css-extract-plugin
module.exports = {"container":"BackNextPagination_container__qjkpG"};